import { BaseMedia } from "typings/media";
import { INavLink } from "office-ui-fabric-react";

interface NavLink 
{
    links: INavLink[];
    isExpanded: boolean;
}

export const folderToNavLink = (
    media: BaseMedia[], 
    onclick: (id: string) => (e: React.MouseEvent<HTMLElement>) => void, 
    selectedId?: string, 
    parentId?: string | null) : NavLink =>
{
    const  result: INavLink[] = [];
    let expanded = false;
    const items = media.filter(x => x.parentId === parentId);
    if (items)
    {
        items.forEach(item =>
        {
            const { links, isExpanded } = folderToNavLink(media, onclick, selectedId, item.id);
            if (selectedId && selectedId === item.id || isExpanded)
            {
                expanded = true;
            }
            
            result.push({
                key: item.id, 
                name: item.data.name.value, 
                links, 
                isExpanded: expanded, 
                url: `/media/${item.id}`, 
                onClick: onclick(item.id) 
            });
        });
    }
    return { links: result, isExpanded: expanded };
};




// WEBPACK FOOTER //
// ./src/components/media/helper.ts